module.exports = __webpack_public_path__ + "media/images/location_list_placeholder-71f3cb986e347d185368a277fe27d2d8.png";